import * as React from 'react';
import style from './Divider.module.css';

interface DividerProps {
  title?: string;
}
function Divider({ title }: DividerProps) {
  return <div className={style.Divider}>{title && <h6>{title}</h6>}</div>;
}

export default Divider;
